<template>
  <div class="BaseWidget flex gap-3 absolute">
    <el-popover
      :show-arrow="false"
      popper-style="box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-color: rgba(256, 256, 256, 0.6); 
  backdrop-filter: blur(15px); 
  border-radius: 8px;"
      placement="bottom-end"
      :width="200"
      trigger="click"
    >
      <div style="max-height: 480px" class="overflow-hidden overflow-y-auto popover-content">
        <el-checkbox-group v-model="selectWidget">
          <el-checkbox
            @change="handleCheckAllChange"
            class="block m-2"
            :label="`全部${selectAllWidgetFlag ? '打开' : '关闭'}`"
            value="all"
          />
          <el-checkbox
            @change="handleCheckboxChange(w.key)"
            class="block m-2"
            v-for="w in layersTreeConfig"
            :key="w.key"
            :label="w.label"
            :value="w.key"
          />
        </el-checkbox-group>
      </div>
      <template #reference>
        <el-button size="large" type="primary">图层</el-button>
      </template>
    </el-popover>

    <el-button-group>
      <el-button
        size="large"
        @click="widgetBtnClickHandle(btn.key)"
        v-for="btn in widgetBtnList.filter((w) => w.show)"
        :key="btn.key"
        type="primary"
        >{{ btn.name }}</el-button
      >
    </el-button-group>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { layersTreeConfig } from '@/config'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { widgetBtnList } from './widgetOptions'

const showPannelKey = defineModel('bandKey')
const selectWidget = ref<string[]>([])
// 触发搜索事件
const emit = defineEmits(['searchHandle'])
/** 图层选择按钮点击事件  */
const widgetBtnClickHandle = (key: string) => {
  showPannelKey.value === key ? (showPannelKey.value = '') : (showPannelKey.value = key)

  emit('searchHandle')
}

/** 是否全部选择图层内容  */
const selectAllWidgetFlag = computed(() => {
  return selectWidget.value.length <= 1
})

const initSelectWidget = () => {
  let list = layersTreeConfig.filter((l) => l.show).map((l) => l.key)
  if (selectAllWidgetFlag.value) {
    list = ['all', ...list]
  }
  selectWidget.value = list
}

initSelectWidget()

/** 全部控制事件 */
const handleCheckAllChange = () => {
  const isSelect = selectWidget.value.includes('all')
  if (isSelect) {
    selectWidget.value = ['all', ...layersTreeConfig.map((l) => l.key)]
  } else {
    selectWidget.value = []
  }

  layersTreeConfig.forEach((l) => {
    handleCheckboxChange(l.key)
  })
}

/** 图层实例控制事件 */
const handleCheckboxChange = async (key: string) => {
  const cesiumobj = await CesiumObj.getInstance()
  const entity = cesiumobj.layerManager.layerMap.get(key)
  if (entity) {
    selectWidget.value.includes(key) ? entity.show() : entity.hide()
  }
}
</script>

<style lang="scss" scoped>
.BaseWidget {
  top: 16px;
  right: 16px;
}

.popover-content {
  ::-webkit-scrollbar {
    width: 8px; /* 滚动条宽度 */
    height: 8px; /* 横向滚动条高度 */
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* 滚动条轨道背景色 */
  }

  ::-webkit-scrollbar-thumb {
    background: #ddd; /* 滚动条滑块背景色 */
    border-radius: 4px; /* 滚动条滑块圆角 */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ccc; /* 滚动条滑块悬停背景色 */
  }

  ::-webkit-scrollbar-button {
    display: none; /* 隐藏滚动条按钮 */
  }
  scrollbar-width: thin; /* 设置滚动条宽度为细 */
  scrollbar-color: #ddd #f1f1f1; /* 滚动条滑块和轨道颜色 */
}
</style>
